import { currentVersion } from '../current-version'
import { actionUpdateSedationLevel } from '../topics/sedation-level'

/** @param {SedationLevel} sedationLevel */
export const actionApplySedationLevel = sedationLevel => {
  let result = {
    version: currentVersion,
    ...actionUpdateSedationLevel(sedationLevel),
    oralSedativesEnabled: true,
    ivEnabled: true,
    airwayEnabled: true,
    vitalsTrackingEnabled: true,
  }

  if (sedationLevel === 'local') {
    result.ivEnabled = false
    result.oralSedativesEnabled = false
  } else if (sedationLevel === 'minimal') {
    result.ivEnabled = false
  }

  for (const key in result) {
    if (result[key] === undefined) {
      delete result[key]
    }
  }

  return result
}
